// For an event to be considered a move content event we want to ensure that
// cut had happened and was followed by paste. So our currentActions array should
// look like this ['contentCut', 'contentPasted'];
// After removing appendTransaction we don't update currentActions with 'contentPasted'
// but leaving it as array in case we decide to change it back or add 'contentCopied'.

export var defaultState = {
  contentMoved: {
    nodeName: undefined,
    size: undefined,
    nodeDepth: undefined,
    currentActions: [],
    nodeTypes: undefined,
    hasSelectedMultipleNodes: undefined
  }
};